import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { BASE_URL, USER_URL } from "../../constant/api";

function SellerBannerView() {
  const { id } = useParams(); // Get the banner ID from the URL
  const [banner, setBanner] = useState([]);
  const [bannerProducts, setBannerProducts] = useState([]); // Store products related to the banner
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  // Fetch banner data by ID
  useEffect(() => {
    const fetchBannerById = async () => {
      try {
        const response = await USER_URL.get(`/products/seller/banners/${id}/`);
        if (response.data) {
          setBanner(response.data.Data.banner); // Set the banner details
          setBannerProducts(response.data.Data.products || []); // Set the associated products
        }
      } catch (error) {
        console.error("Error fetching banner:", error.message || error);
      }
    };

    if (id) {
      fetchBannerById();
    }
  }, [id, token]);
  console.log(bannerProducts);

  if (!banner) {
    return (
      <div className="mt-6 text-center text-gray-500">No Banner Found</div>
    );
  }

  return (
    <div>
      <div className="mt-5 rounded-lg border-2 bg-gray-50 p-5 shadow-lg">
        <div className="flex justify-end text-center">
          <button
            onClick={() => navigate(-1)} // Use navigate(-1) to go back
            className="flex items-center text-sm font-medium text-green-600 hover:text-green-700 focus:outline-none"
          >
            <span>&lt; Back to Banner List</span>
          </button>
        </div>
        <h2 className="mb-6 text-center text-3xl font-bold text-green-700">
          Banner
        </h2>

        {/* Banner Image and Details */}
        <div className="mb-8 grid grid-cols-1 gap-6 sm:grid-cols-2">
          <div>
            {/* Left side: Banner Image */}
            <div className="relative">
              <h3 className="mb-3 text-xl font-semibold text-gray-800">
                Banner Image
              </h3>
              {banner.banner ? (
                <img
                  src={
                    banner.banner instanceof File
                      ? URL.createObjectURL(banner.banner) // Show selected logo file
                      : `${BASE_URL}${banner.banner}` // Show logo from API
                  }
                  alt="Banner"
                  className="mb-4 h-48 w-full rounded-md object-cover"
                />
              ) : (
                <div className="mb-4 flex h-44 w-full items-center justify-center rounded-md bg-gray-100 text-gray-500">
                  No Banner Image
                </div>
              )}
            </div>
          </div>

          {/* Right side: Banner Info */}
          <div>
            <div className="mb-4 rounded-lg border bg-white p-4 shadow-sm">
              <span className="mb-1 block text-sm font-medium text-gray-600">
                Banner Title
              </span>
              <p className="text-lg font-semibold text-gray-800">
                {banner.title || "No Title"}
              </p>
            </div>
           

            <div className="p-4 bg-white border rounded-lg shadow-sm mb-4">
              <span className="block text-sm font-medium text-gray-600 mb-1">Start Date</span>
              <p className="text-lg font-semibold text-gray-800">{banner.start_date || "yyyy/mm/dd"}</p>
            </div>

            <div className="p-4 bg-white border rounded-lg shadow-sm">
              <span className="block text-sm font-medium text-gray-600 mb-1">End Date</span>
              <p className="text-lg font-semibold text-gray-800">{banner.end_date || "yyyy/mm/dd"}</p>
            </div>
          </div>
        </div>

        {/* Products in the Banner */}
        <div className="mt-6">
          <h4 className="mb-4 text-xl font-bold">Products in Banner</h4>
          {bannerProducts.length > 0 ? (
            <div className="overflow-x-auto">
              <table className="w-full text-left">
                <thead>
                  <tr>
                    <th className="px-2 py-2 text-sm font-bold text-green-500">
                      Item No
                    </th>
                    <th className="px-2 py-2 text-sm font-bold text-green-500">
                      Product Code
                    </th>
                    <th className="px-2 py-2 text-sm font-bold text-green-500">
                      Product Name
                    </th>
                    <th className="px-2 py-2 text-sm font-bold text-green-500">
                      Stock
                    </th>
                    <th className="px-2 py-2 text-sm font-bold text-green-500">
                      Price
                    </th>
                    <th className="px-2 py-2 text-sm font-bold text-green-500">
                      Image
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {bannerProducts.map((product, idx) => (
                    <tr key={product.id}>
                      <td className="px-2 py-2">
                        <div className="rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-800">
                          {idx + 1}
                        </div>
                      </td>

                      <td className="px-2 py-2">
                        <div className="rounded-lg border border-gray-300 px-2 py-2 text-sm text-gray-800">
                          {product.product_code || "N/A"}
                        </div>
                      </td>

                      <td className="px-2 py-2">
                        <div className="rounded-lg border border-gray-300 px-2 py-2 text-sm text-gray-800">
                          {product.product_name || "N/A"}
                        </div>
                      </td>

                      <td className="px-2 py-2">
                        <div className="rounded-lg border border-gray-300 px-2 py-2 text-sm text-gray-800">
                          {product.stock || "N/A"}
                        </div>
                      </td>

                      <td className="px-2 py-2">
                        <div className="rounded-lg border border-gray-300 px-2 py-2 text-sm text-gray-800">
                          {product.price || "N/A"}
                        </div>
                      </td>

                      <td className="px-2 py-2">
                        {product.product_banner_image ? (
                          <img
                            src={
                              product.product_banner_image instanceof File
                                ? URL.createObjectURL(
                                    product.product_banner_image,
                                  ) // Show selected logo file
                                : `${BASE_URL}${product.product_banner_image}` // Show logo from API
                            }
                            alt={product.name || "Product Image"}
                            className="h-20 w-28 rounded object-cover"
                          />
                        ) : (
                          <div className="flex h-20 w-28 items-center justify-center rounded border border-gray-300 bg-gray-100">
                            <span className="text-xs text-gray-500">
                              No Image
                            </span>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p className="text-gray-500">No Products in this Banner</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default SellerBannerView;
